import { render, staticRenderFns } from "./swInvestmentVentures.vue?vue&type=template&id=79cf80d9&scoped=true"
import script from "./swInvestmentVentures.vue?vue&type=script&lang=js"
export * from "./swInvestmentVentures.vue?vue&type=script&lang=js"
import style1 from "./swInvestmentVentures.vue?vue&type=style&index=1&id=79cf80d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cf80d9",
  null
  
)

export default component.exports